import { render, staticRenderFns } from "./genre-pills.vue?vue&type=template&id=2a81316a&scoped=true"
import script from "./genre-pills.vue?vue&type=script&lang=js"
export * from "./genre-pills.vue?vue&type=script&lang=js"
import style0 from "./genre-pills.vue?vue&type=style&index=0&id=2a81316a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a81316a",
  null
  
)

export default component.exports